import { useMutation } from "react-query";
import { deleteOfficeKey } from "../../../../actions/CarrierAgreementMgmt/Security";

const useDeleteOfficeKey = () => {
  return useMutation(deleteOfficeKey);
};
export default useDeleteOfficeKey;
